module.exports = __webpack_public_path__ + "fonts/GothamBook.b54724f5.ttf";